"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionsCheckQueryParamsSchema = exports.validateValueErrors = exports.isValidValue = exports.optionalAddressSchema = exports.addressSchema = exports.makeSchemaFieldsOptional = exports.partnerIdHeaderSchema = void 0;
const index_1 = require("../index");
const joi_1 = __importDefault(require("joi"));
exports.partnerIdHeaderSchema = joi_1.default.object({
    partnerid: joi_1.default.string().required()
})
    .required()
    .unknown(true);
const makeSchemaFieldsOptional = (joiSchema, optionalFields) => {
    if (optionalFields && optionalFields.length > 0) {
        return joiSchema.fork(optionalFields, (schema) => schema.optional());
    }
    return joiSchema.fork(Object.keys(joiSchema), (schema) => schema.optional());
};
exports.makeSchemaFieldsOptional = makeSchemaFieldsOptional;
exports.addressSchema = joi_1.default.object().keys({
    address1: joi_1.default.string().required(),
    address2: joi_1.default.optional().empty(),
    city: joi_1.default.string().required(),
    state: joi_1.default.string().required(),
    postal: joi_1.default.optional().empty(),
    country: joi_1.default.string().required(),
    shortAddress: joi_1.default.optional().empty()
});
exports.optionalAddressSchema = joi_1.default.object().keys({
    address1: joi_1.default.string().allow(""),
    address2: joi_1.default.optional().allow(),
    city: joi_1.default.string().allow(""),
    state: joi_1.default.string().allow(""),
    postal: joi_1.default.optional().allow(""),
    country: joi_1.default.string().required()
});
const isValidValue = (value, field, joiSchema) => {
    const validation = joiSchema.validate(value);
    if (validation.error) {
        throw new Error(`${field} ${validation.error.details[0].message}`);
    }
    return undefined;
};
exports.isValidValue = isValidValue;
const validateValueErrors = (errors, value, field, fieldName, joiSchema) => {
    const validation = joiSchema.validate(value);
    if (validation.error) {
        errors.push(new index_1.DataError(index_1.eErrorCode.DATA_VALIDATION_ERROR, field, `${fieldName} ${validation.error.details[0].message}`));
    }
};
exports.validateValueErrors = validateValueErrors;
exports.SanctionsCheckQueryParamsSchema = joi_1.default.object({
    name: joi_1.default.string().required(),
    address: joi_1.default.string().optional(),
    sendEmail: joi_1.default.string().optional()
});
//# sourceMappingURL=utilSchemas.js.map